<template>
    <div class="relative m-0" v-click-outside="closeDropdown">
        <button @click="isOpen = !isOpen" class="">
            <slot></slot>
        </button>
        <div v-show="isOpen" @click="isOpen = false"
            class="absolute flex flex-col z-10 right-0 mt-2 p-2 gap-1 w-48 rounded-md shadow-lg bg-dark-purple-background ring-1 ring-black ring-opacity-5">
            <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                <a v-for="(option, index) in options" :key="index" @click="selectOption(option)" href="#"
                    class="block px-2 py-2 text-sm text-white rounded-lg hover:bg-purple-background" role="menuitem">
                    {{ option.name }}
                </a>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        options: {
            type: Array,
            required: true,
            validator: (options) => {
                return options.every(option =>
                    typeof option === 'string' ||
                    (typeof option === 'object' && typeof option.name === 'string' && typeof option.callback === 'function')
                );
            }
        }
    },
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        selectOption(option) {
            if (typeof option === 'string') {
                this.$emit('selected', option);
            } else {
                option.callback();
            }
            this.isOpen = false;
        },
        closeDropdown() {
            this.isOpen = false;
        }
    }
}
</script>